import React from 'react'
import { connect } from 'react-redux'
import './footer.scss'

class Footer extends React.Component {
    render() {
        return (
            <footer className="Footer">
                &copy; Eugene Blokhin 2019
            </footer>
        );
    }
}

export default connect()(Footer);